import type { ContentType } from "@/types/content";
import type { ChatTabId } from "@/components/chat/ChatRoot";

/**
 * Defines which tabs are allowed for each content type.
 * 
 * Document types (pdf, doc, web, text) → chapters on right panel
 * Media types (youtube, video, audio, recording) → NO chapters on right (they have chapters in MediaInsightsTabs on left)
 */
export const CONTENT_CHAT_TABS: Record<ContentType, ChatTabId[]> = {
  // Document types - include chapters
  pdf: ["chat", "flashcards", "quizzes", "notes", "chapters", "summary"],
  doc: ["chat", "flashcards", "quizzes", "notes", "chapters", "summary"],
  web: ["chat", "flashcards", "quizzes", "notes", "chapters", "summary"],
  text: ["chat", "flashcards", "quizzes", "notes", "chapters", "summary"],

  // Media types - NO chapters (they have it on the left panel)
  youtube: ["chat", "flashcards", "quizzes", "notes", "summary"],
  video: ["chat", "flashcards", "quizzes", "notes", "summary"],
  audio: ["chat", "flashcards", "quizzes", "notes", "summary"],
  recording: ["chat", "flashcards", "quizzes", "notes", "summary"],

  // Chat type - only chat
  chat: ["chat"],
};
